import React from 'react'

import './CrossSellingItem.scss'
import {ProductModel} from "../../Models/ProductModel";
import {useGetDiscount} from "../../hooks/useGetDiscount";
import Plus from '../../Assets/Icons/plus.svg'
import Moins from '../../Assets/Icons/moins.svg'
import {useTranslation} from "react-i18next";
import {useFormatCurrency} from "../../hooks/useFormatCurrency";

interface MenuItemProps {
    item: ProductModel,
    quantity: number,
    onAddItem: () => void
    onPlus: () => void
    onMoins: () => void
}

const CrossSellingItem: React.FC<MenuItemProps> = ({item, quantity, onAddItem, onPlus, onMoins}: MenuItemProps) => {
    const {t} = useTranslation('common')
    const formatCurrency = useFormatCurrency()
    const getDiscount = useGetDiscount()

    const discount = getDiscount(item.automaticDiscounts, new Date())

    const getQuantityDiscountText = () => {
        if(discount) {
            const rate = discount.discount.rate
            const offered = discount.discount.rateTotal - discount.discount.rate
            return t('discount.text', {
                rate,
                boughtLabel: rate > 1 ? t('discount.boughtPlural') : t('discount.bought'),
                offered,
                offeredLabel: offered > 1 ? t('discount.offeredPlural') : t('discount.offered'),
            })
        }
        return ''
    }

    return (
        <div className="crossSellingItem" >
            <div className="crossSellingItem__cadre">
                {
                    discount && (
                        <div className={`crossSellingItem__cadre__discount ${discount.discount.type === 'quantity' ? 'quantity' : 'percent'}`}>
                            {
                                discount.discount.type === 'quantity' ? (
                                    <p>{getQuantityDiscountText()}</p>
                                ) : (
                                    <p>-{discount.discount.rate}%</p>
                                )
                            }
                        </div>
                    )
                }
                <div className="crossSellingItem__cadre__imgContainer">
                    <img
                        src={item.product.image}
                        alt="item"
                    />
                </div>
            </div>
            {
                discount && discount.discount.type === 'percent' ? (
                    <p className="crossSellingItem--prix">{formatCurrency(item.priceTTC - (item.priceTTC * (discount.discount.rate / 100)))} <span>{formatCurrency(item.priceTTC)}</span></p>
                ) : (
                    <p className="crossSellingItem--prix">{formatCurrency(item.priceTTC)}</p>
                )
            }
            <p className="crossSellingItem--name">{item.product.name}</p>
            {
                quantity === 0 ? (
                        <button  className="crossSellingItem--button" onClick={onAddItem}>
                            <img src={Plus}/>
                        </button>
                ) : (

                    <div className="crossSellingItem__buttonsContainer">
                        <div className="crossSellingItem__buttonsContainer__quantity"><p>{quantity}</p></div>
                        <img src={Moins} onClick={onMoins}/>
                        <img src={Plus} onClick={onPlus}/>
                    </div>
                )
            }
        </div>
    )
}

export default CrossSellingItem;
